class Header {
  constructor() {
    this.stickyHeader();
    this.navigation();
    this.menuItems();
  }

  menuItems = () => {
    const menuItems = document.querySelectorAll(".menu-item-has-children");
    const subMenus = document.querySelectorAll(".sub-menu");
    menuItems.forEach((item, index) => {
      let link = item.querySelector("a");
      link.addEventListener("click", (e) => {
        e.preventDefault();
        item.classList.toggle("active");
        subMenus[index].classList.toggle("active");
      });
    });
  };

  navigation = () => {
    const toggleBtn = document.querySelector(".js-hamburger");
    const header = document.querySelector(".js-header");
    const nav = document.querySelector(".js-navigation");
    toggleBtn.addEventListener("click", (e) => {
      header.classList.toggle("open");
      toggleBtn.classList.toggle("open");
      nav.classList.toggle("open");
      document.body.classList.toggle("stop-scroll");
    });
  };

  stickyHeader = () => {
    const header = document.querySelector(".js-header");
    let prevPosY = window.scrollY;
    if (window.scrollY > 10) {
      header.classList.add("not-top");
    }

    addEventListener("scroll", () => {
      const posY = window.scrollY;
      if (posY < 10) {
        header.classList.remove("not-top");
      } else {
        header.classList.add("not-top");
      }
      if (posY <= prevPosY || posY <= 0) {
        header.classList.remove("hide");
      } else {
        header.classList.add("hide");
      }
      prevPosY = posY;
    });
  };
}
new Header();
